<template>
  <div class="b-block__seperator--md">
    <Loader v-if="isLoading" />
    <Alert
      v-if="errorMessages.length"
      :messages="errorMessages"
      :dismissible="false" />

    <template v-if="items.length">
      <template v-for="item in items" :key="item.id">
        <PurchaseMovie v-if="item.type === 'movie'" :item="item" />
        <PurchaseCafe v-if="item.type === 'cafe'" :item="item" />
      </template>
    </template>
    <template v-else>
      <div class="b-upcoming-purchases">
        <div class="b-upcoming-purchases__icon"><i class="icon-movie"></i></div>
        <div class="b-upcoming-purchases__text">
          {{ dictionary.noResultsFound }}
        </div>

        <Anchor v-if="link" :item="link" class="b-block__find-movie-btn" />
      </div>
    </template>
  </div>
</template>

<script setup>
import { getCurrentInstance, onBeforeMount, onMounted, ref } from 'vue'
import Loader from './../components/Shared/Loader.vue'
import Alert from './../components/Shared/Alert.vue'
import postRequestHandler from '../../lib/postRequestHandler'
import getErrorMessage from './../../lib/getErrorMessage'
import PurchaseMovie from '../components/PurchaseMovie.vue'
import PurchaseCafe from '../components/PurchaseCafe.vue'
import Anchor from './../components/Shared/Anchor.vue'
import * as lib from './../../lib/lib'

const { configuration, dictionary } =
  getCurrentInstance().appContext.config.globalProperties
const isLoading = ref(false)
const errorMessages = ref([])
const items = ref([])
const link = ref(null)

onBeforeMount(() => {
  const { backLink } = lib.getData('myPurchasesData')
  link.value = backLink
})

onMounted(async () => {
  onSubmitForm()
})

const onSubmitForm = async () => {
  if (isLoading.value) {
    return false
  }
  isLoading.value = true
  errorMessages.value = []
  const postData = {}
  await postRequestHandler({
    postData,
    endpoint: configuration.endpointFetchData,
    successCallback: (response) => {
      const { records } = response.data
      console.log(records)
      items.value = records
      handleSuccess()
    },
    errorCallback: handleError,
  })
}

const handleSuccess = () => {
  isLoading.value = false
  errorMessages.value = []
}

const handleError = (messages) => {
  isLoading.value = false
  errorMessages.value = getErrorMessage(
    messages,
    dictionary.defaultErrorMessage
  )
}
</script>
